import React from 'react';
const WebsiteLink = ({ color = 'black', className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="15"
      viewBox="0 0 29 15"
      fill="none"
      className={className}
    >
      <path
        d="M12.3032 13.5H6.94328C3.66171 13.5 1 10.817 1 7.50919C1 5.85528 1.67454 4.34839 2.75017 3.26417C3.82579 2.17994 5.32073 1.5 6.96151 1.5H12.3032M16.6786 13.5H22.0385C23.6793 13.5 25.1742 12.8201 26.2498 11.7358C27.3255 10.6516 28 9.14472 28 7.49081C28 4.183 25.3383 1.5 22.0567 1.5H16.6786M9.36799 7.50919H19.6138"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default WebsiteLink;
